function log (msg) {
	console.log(msg)
}

export default log
